var map = {
	"./assets/audio/01.mp3": 21072,
	"./assets/audio/02.mp3": 86039,
	"./assets/audio/03.mp3": 51790,
	"./assets/audio/04.mp3": 10292,
	"./assets/audio/05.mp3": 12796,
	"./assets/audio/06.mp3": 29118,
	"./assets/audio/07.mp3": 33158,
	"./assets/audio/08.mp3": 70810,
	"./assets/audio/09.mp3": 6495,
	"./assets/audio/10.mp3": 57037,
	"./assets/cards/backcard.png": 39446,
	"./assets/cards/mayores/el-carro.jpg": 51234,
	"./assets/cards/mayores/el-carro.png": 1714,
	"./assets/cards/mayores/el-colgado.jpg": 95028,
	"./assets/cards/mayores/el-colgado.png": 56684,
	"./assets/cards/mayores/el-diablo.jpg": 54237,
	"./assets/cards/mayores/el-diablo.png": 56833,
	"./assets/cards/mayores/el-emperador.jpg": 37944,
	"./assets/cards/mayores/el-emperador.png": 71635,
	"./assets/cards/mayores/el-ermitanio.jpg": 30092,
	"./assets/cards/mayores/el-hermitaño.png": 10559,
	"./assets/cards/mayores/el-juicio.jpg": 84360,
	"./assets/cards/mayores/el-juicio.png": 76622,
	"./assets/cards/mayores/el-loco.jpg": 54470,
	"./assets/cards/mayores/el-loco.png": 33710,
	"./assets/cards/mayores/el-mago.jpg": 26710,
	"./assets/cards/mayores/el-mago.png": 15260,
	"./assets/cards/mayores/el-mundo.jpg": 64962,
	"./assets/cards/mayores/el-mundo.png": 4201,
	"./assets/cards/mayores/el-papa.jpg": 34900,
	"./assets/cards/mayores/el-papa.png": 99523,
	"./assets/cards/mayores/el-sol.jpg": 12792,
	"./assets/cards/mayores/el-sol.png": 44914,
	"./assets/cards/mayores/la-emperatriz.jpg": 62490,
	"./assets/cards/mayores/la-emperatriz.png": 80916,
	"./assets/cards/mayores/la-estrella.jpg": 48390,
	"./assets/cards/mayores/la-estrella.png": 82617,
	"./assets/cards/mayores/la-fuerza.jpg": 3170,
	"./assets/cards/mayores/la-fuerza.png": 65906,
	"./assets/cards/mayores/la-justicia.jpg": 86877,
	"./assets/cards/mayores/la-justicia.png": 45717,
	"./assets/cards/mayores/la-luna.jpg": 79366,
	"./assets/cards/mayores/la-luna.png": 18680,
	"./assets/cards/mayores/la-muerte.jpg": 12358,
	"./assets/cards/mayores/la-muerte.png": 19974,
	"./assets/cards/mayores/la-rueda-de-la-fortuna.jpg": 50699,
	"./assets/cards/mayores/la-rueda-de-la-fortuna.png": 80715,
	"./assets/cards/mayores/la-sacerdotisa.jpg": 91742,
	"./assets/cards/mayores/la-sacerdotisa.png": 93623,
	"./assets/cards/mayores/la-templanza.jpg": 62085,
	"./assets/cards/mayores/la-templanza.png": 45675,
	"./assets/cards/mayores/la-torre.jpg": 60333,
	"./assets/cards/mayores/la-torre.png": 76048,
	"./assets/cards/mayores/los-enamorados.jpg": 67424,
	"./assets/cards/mayores/los-enamorados.png": 81564,
	"./assets/cards/menores/bastos/as.jpg": 67855,
	"./assets/cards/menores/bastos/caballo.jpg": 7740,
	"./assets/cards/menores/bastos/cinco.jpg": 27970,
	"./assets/cards/menores/bastos/cuatro.jpg": 21118,
	"./assets/cards/menores/bastos/diez.jpg": 37482,
	"./assets/cards/menores/bastos/dos.jpg": 77052,
	"./assets/cards/menores/bastos/nueve.jpg": 34954,
	"./assets/cards/menores/bastos/ocho.jpg": 90416,
	"./assets/cards/menores/bastos/reina.jpg": 62229,
	"./assets/cards/menores/bastos/rey.jpg": 37417,
	"./assets/cards/menores/bastos/seis.jpg": 50591,
	"./assets/cards/menores/bastos/siete.jpg": 70411,
	"./assets/cards/menores/bastos/sota.jpg": 13173,
	"./assets/cards/menores/bastos/tres.jpg": 80507,
	"./assets/cards/menores/copas/as.jpg": 66662,
	"./assets/cards/menores/copas/caballo.jpg": 89035,
	"./assets/cards/menores/copas/cinco.jpg": 50594,
	"./assets/cards/menores/copas/cuatro.jpg": 90052,
	"./assets/cards/menores/copas/diez.jpg": 23379,
	"./assets/cards/menores/copas/dos.jpg": 14987,
	"./assets/cards/menores/copas/nueve.jpg": 43218,
	"./assets/cards/menores/copas/ocho.jpg": 59012,
	"./assets/cards/menores/copas/reina.jpg": 43595,
	"./assets/cards/menores/copas/rey.jpg": 56246,
	"./assets/cards/menores/copas/seis.jpg": 58256,
	"./assets/cards/menores/copas/siete.jpg": 66327,
	"./assets/cards/menores/copas/sota.jpg": 1032,
	"./assets/cards/menores/copas/tres.jpg": 4290,
	"./assets/cards/menores/espadas/as.jpg": 71632,
	"./assets/cards/menores/espadas/caballo.jpg": 67984,
	"./assets/cards/menores/espadas/cinco.jpg": 3791,
	"./assets/cards/menores/espadas/cuatro.jpg": 63177,
	"./assets/cards/menores/espadas/diez.jpg": 29835,
	"./assets/cards/menores/espadas/dos.jpg": 3713,
	"./assets/cards/menores/espadas/nueve.jpg": 1980,
	"./assets/cards/menores/espadas/ocho.jpg": 75761,
	"./assets/cards/menores/espadas/reina.jpg": 42112,
	"./assets/cards/menores/espadas/rey.jpg": 44755,
	"./assets/cards/menores/espadas/seis.jpg": 99868,
	"./assets/cards/menores/espadas/siete.jpg": 78226,
	"./assets/cards/menores/espadas/sota.jpg": 88363,
	"./assets/cards/menores/espadas/tres.jpg": 44148,
	"./assets/cards/menores/oros/as.jpg": 92575,
	"./assets/cards/menores/oros/caballo.jpg": 29869,
	"./assets/cards/menores/oros/cinco.jpg": 20743,
	"./assets/cards/menores/oros/cuatro.jpg": 9158,
	"./assets/cards/menores/oros/diez.jpg": 60103,
	"./assets/cards/menores/oros/dos.jpg": 43058,
	"./assets/cards/menores/oros/nueve.jpg": 63473,
	"./assets/cards/menores/oros/ocho.jpg": 78399,
	"./assets/cards/menores/oros/reina.jpg": 15556,
	"./assets/cards/menores/oros/rey.jpg": 47541,
	"./assets/cards/menores/oros/seis.jpg": 47275,
	"./assets/cards/menores/oros/siete.jpg": 42910,
	"./assets/cards/menores/oros/sota.jpg": 51206,
	"./assets/cards/menores/oros/tres.jpg": 52194,
	"./assets/corte/mayores/el-carro.jpg": 32223,
	"./assets/corte/mayores/el-colgado.jpg": 30681,
	"./assets/corte/mayores/el-diablo.jpg": 29112,
	"./assets/corte/mayores/el-emperador.jpg": 55218,
	"./assets/corte/mayores/el-ermitanio.jpg": 21103,
	"./assets/corte/mayores/el-juicio.jpg": 78023,
	"./assets/corte/mayores/el-loco.jpg": 33339,
	"./assets/corte/mayores/el-mago.jpg": 58891,
	"./assets/corte/mayores/el-mundo.jpg": 93708,
	"./assets/corte/mayores/el-papa.jpg": 13138,
	"./assets/corte/mayores/el-sol.jpg": 50293,
	"./assets/corte/mayores/la-emperatriz.jpg": 1319,
	"./assets/corte/mayores/la-estrella.jpg": 63526,
	"./assets/corte/mayores/la-fuerza.jpg": 86203,
	"./assets/corte/mayores/la-justicia.jpg": 61459,
	"./assets/corte/mayores/la-luna.jpg": 3705,
	"./assets/corte/mayores/la-muerte.jpg": 45318,
	"./assets/corte/mayores/la-rueda-de-la-fortuna.jpg": 15409,
	"./assets/corte/mayores/la-sacerdotisa.jpg": 65209,
	"./assets/corte/mayores/la-templanza.jpg": 18095,
	"./assets/corte/mayores/la-torre.jpg": 53762,
	"./assets/corte/mayores/los-enamorados.jpg": 11676,
	"./assets/corte/menores/bastos/as.jpg": 82862,
	"./assets/corte/menores/bastos/caballo.jpg": 70529,
	"./assets/corte/menores/bastos/cinco.jpg": 26253,
	"./assets/corte/menores/bastos/cuatro.jpg": 12695,
	"./assets/corte/menores/bastos/diez.jpg": 13376,
	"./assets/corte/menores/bastos/dos.jpg": 40716,
	"./assets/corte/menores/bastos/nueve.jpg": 18789,
	"./assets/corte/menores/bastos/ocho.jpg": 55117,
	"./assets/corte/menores/bastos/reina.jpg": 301,
	"./assets/corte/menores/bastos/rey.jpg": 14539,
	"./assets/corte/menores/bastos/seis.jpg": 60553,
	"./assets/corte/menores/bastos/siete.jpg": 72827,
	"./assets/corte/menores/bastos/sota.jpg": 49559,
	"./assets/corte/menores/bastos/tres.jpg": 6999,
	"./assets/corte/menores/copas/as.jpg": 85546,
	"./assets/corte/menores/copas/caballo.jpg": 34380,
	"./assets/corte/menores/copas/cinco.jpg": 84994,
	"./assets/corte/menores/copas/cuatro.jpg": 644,
	"./assets/corte/menores/copas/diez.jpg": 3553,
	"./assets/corte/menores/copas/dos.jpg": 78198,
	"./assets/corte/menores/copas/nueve.jpg": 77865,
	"./assets/corte/menores/copas/ocho.jpg": 77328,
	"./assets/corte/menores/copas/reina.jpg": 26773,
	"./assets/corte/menores/copas/rey.jpg": 78935,
	"./assets/corte/menores/copas/seis.jpg": 61083,
	"./assets/corte/menores/copas/siete.jpg": 67719,
	"./assets/corte/menores/copas/sota.jpg": 3768,
	"./assets/corte/menores/copas/tres.jpg": 44576,
	"./assets/corte/menores/espadas/as.jpg": 94290,
	"./assets/corte/menores/espadas/caballo.jpg": 46064,
	"./assets/corte/menores/espadas/cinco.jpg": 78263,
	"./assets/corte/menores/espadas/cuatro.jpg": 50128,
	"./assets/corte/menores/espadas/diez.jpg": 22471,
	"./assets/corte/menores/espadas/dos.jpg": 37754,
	"./assets/corte/menores/espadas/nueve.jpg": 96145,
	"./assets/corte/menores/espadas/ocho.jpg": 31601,
	"./assets/corte/menores/espadas/reina.jpg": 40363,
	"./assets/corte/menores/espadas/rey.jpg": 56776,
	"./assets/corte/menores/espadas/seis.jpg": 64703,
	"./assets/corte/menores/espadas/siete.jpg": 36712,
	"./assets/corte/menores/espadas/sota.jpg": 79523,
	"./assets/corte/menores/espadas/tres.jpg": 63824,
	"./assets/corte/menores/oros/as.jpg": 28015,
	"./assets/corte/menores/oros/caballo.jpg": 7622,
	"./assets/corte/menores/oros/cinco.jpg": 11626,
	"./assets/corte/menores/oros/cuatro.jpg": 91783,
	"./assets/corte/menores/oros/diez.jpg": 80058,
	"./assets/corte/menores/oros/dos.jpg": 93446,
	"./assets/corte/menores/oros/nueve.jpg": 68596,
	"./assets/corte/menores/oros/ocho.jpg": 25721,
	"./assets/corte/menores/oros/reina.jpg": 37495,
	"./assets/corte/menores/oros/rey.jpg": 27951,
	"./assets/corte/menores/oros/seis.jpg": 80673,
	"./assets/corte/menores/oros/siete.jpg": 27917,
	"./assets/corte/menores/oros/sota.jpg": 1260,
	"./assets/corte/menores/oros/tres.jpg": 83326,
	"./assets/dark/mayores/el-carro.jpg": 96887,
	"./assets/dark/mayores/el-colgado.jpg": 18879,
	"./assets/dark/mayores/el-diablo.jpg": 63225,
	"./assets/dark/mayores/el-emperador.jpg": 44637,
	"./assets/dark/mayores/el-ermitanio.jpg": 58445,
	"./assets/dark/mayores/el-juicio.jpg": 27985,
	"./assets/dark/mayores/el-loco.jpg": 63430,
	"./assets/dark/mayores/el-mago.jpg": 79363,
	"./assets/dark/mayores/el-mundo.jpg": 40809,
	"./assets/dark/mayores/el-papa.jpg": 97551,
	"./assets/dark/mayores/el-sol.jpg": 93545,
	"./assets/dark/mayores/la-emperatriz.jpg": 24293,
	"./assets/dark/mayores/la-estrella.jpg": 80271,
	"./assets/dark/mayores/la-fuerza.jpg": 66049,
	"./assets/dark/mayores/la-justicia.jpg": 14936,
	"./assets/dark/mayores/la-luna.jpg": 5759,
	"./assets/dark/mayores/la-muerte.jpg": 30939,
	"./assets/dark/mayores/la-rueda-de-la-fortuna.jpg": 30578,
	"./assets/dark/mayores/la-sacerdotisa.jpg": 4662,
	"./assets/dark/mayores/la-templanza.jpg": 32048,
	"./assets/dark/mayores/la-torre.jpg": 56951,
	"./assets/dark/mayores/los-enamorados.jpg": 95127,
	"./assets/dark/menores/bastos/as.jpg": 3521,
	"./assets/dark/menores/bastos/caballo.jpg": 49693,
	"./assets/dark/menores/bastos/cinco.jpg": 75286,
	"./assets/dark/menores/bastos/cuatro.jpg": 45903,
	"./assets/dark/menores/bastos/diez.jpg": 39162,
	"./assets/dark/menores/bastos/dos.jpg": 67109,
	"./assets/dark/menores/bastos/nueve.jpg": 42152,
	"./assets/dark/menores/bastos/ocho.jpg": 43244,
	"./assets/dark/menores/bastos/reina.jpg": 46033,
	"./assets/dark/menores/bastos/rey.jpg": 5267,
	"./assets/dark/menores/bastos/seis.jpg": 62530,
	"./assets/dark/menores/bastos/siete.jpg": 24352,
	"./assets/dark/menores/bastos/sota.jpg": 62220,
	"./assets/dark/menores/bastos/tres.jpg": 75079,
	"./assets/dark/menores/copas/as.jpg": 85509,
	"./assets/dark/menores/copas/caballo.jpg": 13067,
	"./assets/dark/menores/copas/cinco.jpg": 95568,
	"./assets/dark/menores/copas/cuatro.jpg": 84808,
	"./assets/dark/menores/copas/diez.jpg": 5341,
	"./assets/dark/menores/copas/dos.jpg": 29269,
	"./assets/dark/menores/copas/nueve.jpg": 20517,
	"./assets/dark/menores/copas/ocho.jpg": 40205,
	"./assets/dark/menores/copas/reina.jpg": 45034,
	"./assets/dark/menores/copas/rey.jpg": 38198,
	"./assets/dark/menores/copas/seis.jpg": 19605,
	"./assets/dark/menores/copas/siete.jpg": 51947,
	"./assets/dark/menores/copas/sota.jpg": 91225,
	"./assets/dark/menores/copas/tres.jpg": 4867,
	"./assets/dark/menores/espadas/as.jpg": 10356,
	"./assets/dark/menores/espadas/caballo.jpg": 76492,
	"./assets/dark/menores/espadas/cinco.jpg": 69491,
	"./assets/dark/menores/espadas/cuatro.jpg": 50391,
	"./assets/dark/menores/espadas/diez.jpg": 44968,
	"./assets/dark/menores/espadas/dos.jpg": 85321,
	"./assets/dark/menores/espadas/nueve.jpg": 62839,
	"./assets/dark/menores/espadas/ocho.jpg": 24056,
	"./assets/dark/menores/espadas/reina.jpg": 690,
	"./assets/dark/menores/espadas/rey.jpg": 66341,
	"./assets/dark/menores/espadas/seis.jpg": 59399,
	"./assets/dark/menores/espadas/siete.jpg": 47318,
	"./assets/dark/menores/espadas/sota.jpg": 45107,
	"./assets/dark/menores/espadas/tres.jpg": 26153,
	"./assets/dark/menores/oros/as.jpg": 39761,
	"./assets/dark/menores/oros/caballo.jpg": 83667,
	"./assets/dark/menores/oros/cinco.jpg": 12,
	"./assets/dark/menores/oros/cuatro.jpg": 45727,
	"./assets/dark/menores/oros/diez.jpg": 93722,
	"./assets/dark/menores/oros/dos.jpg": 65098,
	"./assets/dark/menores/oros/nueve.jpg": 23812,
	"./assets/dark/menores/oros/ocho.jpg": 69331,
	"./assets/dark/menores/oros/reina.jpg": 31438,
	"./assets/dark/menores/oros/rey.jpg": 48613,
	"./assets/dark/menores/oros/seis.jpg": 40618,
	"./assets/dark/menores/oros/siete.jpg": 40852,
	"./assets/dark/menores/oros/sota.jpg": 78143,
	"./assets/dark/menores/oros/tres.jpg": 82268,
	"./assets/images/1.jpg": 97097,
	"./assets/images/about/el-mago-1.jpg": 59126,
	"./assets/images/about/el-mago-10.jpg": 46940,
	"./assets/images/about/el-mago-11.jpg": 15497,
	"./assets/images/about/el-mago-12.jpg": 65915,
	"./assets/images/about/el-mago-13.jpg": 75420,
	"./assets/images/about/el-mago-14.jpg": 41747,
	"./assets/images/about/el-mago-15.jpg": 85627,
	"./assets/images/about/el-mago-16.jpg": 37283,
	"./assets/images/about/el-mago-17.jpg": 32227,
	"./assets/images/about/el-mago-18.jpg": 684,
	"./assets/images/about/el-mago-2.jpg": 27015,
	"./assets/images/about/el-mago-3.jpg": 18043,
	"./assets/images/about/el-mago-4.jpg": 60603,
	"./assets/images/about/el-mago-5.jpg": 13629,
	"./assets/images/about/el-mago-6.jpg": 1681,
	"./assets/images/about/el-mago-7.jpg": 75565,
	"./assets/images/about/el-mago-8.jpg": 86987,
	"./assets/images/about/el-mago-9.jpg": 57279,
	"./assets/images/about/el-mago.jpg": 11151,
	"./assets/images/abundancia/fondo.jpg": 47747,
	"./assets/images/amor/fondo.jpg": 6285,
	"./assets/images/amor/light.jpg": 38653,
	"./assets/images/arrow_left.png": 38458,
	"./assets/images/atraccion/fondo.jpg": 98083,
	"./assets/images/autoconocimiento/fondo.jpg": 55232,
	"./assets/images/bloqueo/fondo.jpg": 55558,
	"./assets/images/calcular.png": 19760,
	"./assets/images/celta/fondo.jpg": 73792,
	"./assets/images/compatibilidad/fondo.jpg": 62933,
	"./assets/images/encrucijada/fondo.jpg": 5096,
	"./assets/images/evolutivo/fondo.jpg": 16856,
	"./assets/images/ex-pareja/fondo.jpg": 22929,
	"./assets/images/footer/facebook.svg": 68679,
	"./assets/images/footer/instagram.svg": 88083,
	"./assets/images/footer/pagos.png": 65734,
	"./assets/images/footer/pagos.webp": 71676,
	"./assets/images/footer/whatsapp.svg": 98012,
	"./assets/images/free.jpeg": 29158,
	"./assets/images/futuro/fondo.jpg": 38222,
	"./assets/images/futuro2/fondo.jpg": 44023,
	"./assets/images/general/acuario.png": 55259,
	"./assets/images/general/aries.png": 96271,
	"./assets/images/general/cancer.png": 70202,
	"./assets/images/general/capricornio.png": 10041,
	"./assets/images/general/escorpio.png": 50246,
	"./assets/images/general/fondo.jpg": 61759,
	"./assets/images/general/geminis.png": 58570,
	"./assets/images/general/leo.png": 82595,
	"./assets/images/general/libra.png": 17021,
	"./assets/images/general/piscis.png": 21695,
	"./assets/images/general/sagitario.png": 22888,
	"./assets/images/general/tauro.png": 37531,
	"./assets/images/general/virgo.png": 9034,
	"./assets/images/homepage/background.jpg": 26275,
	"./assets/images/homepage/background.png": 97743,
	"./assets/images/homepage/child-1835730_1280.jpg": 56286,
	"./assets/images/homepage/fondo.jpg": 87546,
	"./assets/images/homepage/inversiones.jpg": 90255,
	"./assets/images/homepage/justicia.jpg": 88578,
	"./assets/images/homepage/moneyu.jpg": 77873,
	"./assets/images/homepage/moving.jpg": 41960,
	"./assets/images/homepage/smiling-woman-1340662_1280.jpg": 2646,
	"./assets/images/homepage/viajes.jpg": 95918,
	"./assets/images/homepage/woman-gd817d42f0_1280.jpg": 83424,
	"./assets/images/iching/1.png": 50308,
	"./assets/images/iching/10.png": 44803,
	"./assets/images/iching/11.png": 45394,
	"./assets/images/iching/12.png": 16774,
	"./assets/images/iching/13.png": 26514,
	"./assets/images/iching/14.png": 29854,
	"./assets/images/iching/15.png": 18310,
	"./assets/images/iching/16.png": 23728,
	"./assets/images/iching/17.png": 57524,
	"./assets/images/iching/18.png": 21070,
	"./assets/images/iching/19.png": 91084,
	"./assets/images/iching/2.png": 93510,
	"./assets/images/iching/20.png": 80522,
	"./assets/images/iching/21.png": 22166,
	"./assets/images/iching/22.png": 21073,
	"./assets/images/iching/23.png": 7908,
	"./assets/images/iching/24.png": 94289,
	"./assets/images/iching/25.png": 17947,
	"./assets/images/iching/26.png": 54199,
	"./assets/images/iching/27.png": 48190,
	"./assets/images/iching/28.png": 28509,
	"./assets/images/iching/29.png": 9062,
	"./assets/images/iching/3.png": 7093,
	"./assets/images/iching/30.png": 89797,
	"./assets/images/iching/31.png": 29288,
	"./assets/images/iching/32.png": 97794,
	"./assets/images/iching/33.png": 60102,
	"./assets/images/iching/34.png": 11320,
	"./assets/images/iching/35.png": 26404,
	"./assets/images/iching/36.png": 58536,
	"./assets/images/iching/37.png": 62138,
	"./assets/images/iching/38.png": 13123,
	"./assets/images/iching/39.png": 83104,
	"./assets/images/iching/4.png": 49972,
	"./assets/images/iching/40.png": 20339,
	"./assets/images/iching/41.png": 12928,
	"./assets/images/iching/42.png": 54234,
	"./assets/images/iching/43.png": 89914,
	"./assets/images/iching/44.png": 33517,
	"./assets/images/iching/45.png": 74512,
	"./assets/images/iching/46.png": 68207,
	"./assets/images/iching/47.png": 2150,
	"./assets/images/iching/48.png": 59488,
	"./assets/images/iching/49.png": 91232,
	"./assets/images/iching/5.png": 51274,
	"./assets/images/iching/50.png": 47219,
	"./assets/images/iching/51.png": 61410,
	"./assets/images/iching/52.png": 56579,
	"./assets/images/iching/53.png": 15008,
	"./assets/images/iching/54.png": 8313,
	"./assets/images/iching/55.png": 25472,
	"./assets/images/iching/56.png": 1111,
	"./assets/images/iching/57.png": 75939,
	"./assets/images/iching/58.png": 14038,
	"./assets/images/iching/59.png": 4741,
	"./assets/images/iching/6.png": 88610,
	"./assets/images/iching/60.png": 58553,
	"./assets/images/iching/61.png": 3333,
	"./assets/images/iching/62.png": 52027,
	"./assets/images/iching/63.png": 48443,
	"./assets/images/iching/64.png": 11589,
	"./assets/images/iching/7.png": 35222,
	"./assets/images/iching/8.png": 73514,
	"./assets/images/iching/9.png": 53937,
	"./assets/images/iching/fondo.jpg": 22227,
	"./assets/images/iching/yan.png": 15156,
	"./assets/images/iching/yin.png": 56842,
	"./assets/images/infidelidad/fondo.jpg": 96325,
	"./assets/images/interior/fondo.jpg": 4782,
	"./assets/images/invert.svg": 50859,
	"./assets/images/login/Screen Recording 2023-04-20 at 17.13.59.mov": 81380,
	"./assets/images/login/noshow.svg": 50040,
	"./assets/images/login/show.svg": 14554,
	"./assets/images/mejor/fondo.jpg": 31268,
	"./assets/images/mejor10/fondo.jpg": 79495,
	"./assets/images/mejor10/new_user.png": 21300,
	"./assets/images/mejor10/user.png": 29522,
	"./assets/images/mejor10/users.png": 19877,
	"./assets/images/natal/fondo.jpg": 94514,
	"./assets/images/navbar/astral.png": 80011,
	"./assets/images/navbar/estelar.ico": 28691,
	"./assets/images/navbar/estelar.png": 55283,
	"./assets/images/navbar/sun.png": 41660,
	"./assets/images/navbar/tarot.png": 25728,
	"./assets/images/personality/abuela.jpg": 6597,
	"./assets/images/personality/agrandada.jpg": 11716,
	"./assets/images/personality/astrologa-bohemia.jpg": 49416,
	"./assets/images/personality/austral.jpg": 96272,
	"./assets/images/personality/barrio.jpg": 19400,
	"./assets/images/personality/campera.jpg": 32022,
	"./assets/images/personality/cariñosa.jpg": 84597,
	"./assets/images/personality/cariñosalatina.jpg": 94555,
	"./assets/images/personality/cheta.jpg": 59134,
	"./assets/images/personality/chismosa.jpg": 40264,
	"./assets/images/personality/citadina.jpg": 16131,
	"./assets/images/personality/comerciante.jpg": 99186,
	"./assets/images/personality/conurbano.jpg": 29559,
	"./assets/images/personality/cordobesa.jpg": 81562,
	"./assets/images/personality/gaucha.jpg": 3031,
	"./assets/images/personality/hippie.jpg": 77419,
	"./assets/images/personality/jubilada.jpg": 57450,
	"./assets/images/personality/maestra.jpg": 68364,
	"./assets/images/personality/marcelo.jpg": 24148,
	"./assets/images/personality/mistica.jpg": 25630,
	"./assets/images/personality/pedante.jpg": 75889,
	"./assets/images/personality/porteña.jpg": 92683,
	"./assets/images/personality/pueblerina.jpg": 77340,
	"./assets/images/personality/puneña.jpg": 7435,
	"./assets/images/preguntas/fondo.jpg": 8087,
	"./assets/images/propio/fondo.jpg": 43453,
	"./assets/images/proteccion/fondo.jpg": 85813,
	"./assets/images/renacer/fondo.jpg": 18884,
	"./assets/images/sino/fondo.jpg": 40103,
	"./assets/images/tapiz.jpg": 17726,
	"./assets/images/tapiz1.jpg": 91708,
	"./assets/images/tapiz12.jpg": 77672,
	"./assets/images/tapiz2.jpg": 97819,
	"./assets/images/tapiz3.jpg": 62892,
	"./assets/images/tapiz4.jpg": 31092,
	"./assets/images/tapiz4.png": 18810,
	"./assets/images/tapiz5.jpg": 36666,
	"./assets/images/temporada/fondo.jpg": 21022,
	"./assets/images/trabajo/fondo.jpg": 92304,
	"./assets/images/vidapasada/fondo.jpg": 78127,
	"./assets/images/view.png": 14343,
	"./assets/marsella/mayores/el-carro.jpg": 16410,
	"./assets/marsella/mayores/el-colgado.jpg": 60211,
	"./assets/marsella/mayores/el-diablo.jpg": 5616,
	"./assets/marsella/mayores/el-emperador.jpg": 18234,
	"./assets/marsella/mayores/el-ermitanio.jpg": 38432,
	"./assets/marsella/mayores/el-juicio.jpg": 95026,
	"./assets/marsella/mayores/el-loco.jpg": 36806,
	"./assets/marsella/mayores/el-mago.jpg": 12960,
	"./assets/marsella/mayores/el-mundo.jpg": 27014,
	"./assets/marsella/mayores/el-papa.jpg": 62178,
	"./assets/marsella/mayores/el-sol.jpg": 87556,
	"./assets/marsella/mayores/la-emperatriz.jpg": 46415,
	"./assets/marsella/mayores/la-estrella.jpg": 71075,
	"./assets/marsella/mayores/la-fuerza.jpg": 27774,
	"./assets/marsella/mayores/la-justicia.jpg": 575,
	"./assets/marsella/mayores/la-luna.jpg": 91209,
	"./assets/marsella/mayores/la-muerte.jpg": 70759,
	"./assets/marsella/mayores/la-rueda-de-la-fortuna.jpg": 79169,
	"./assets/marsella/mayores/la-sacerdotisa.jpg": 61662,
	"./assets/marsella/mayores/la-templanza.jpg": 63923,
	"./assets/marsella/mayores/la-torre.jpg": 24891,
	"./assets/marsella/mayores/los-enamorados.jpg": 13306,
	"./assets/marsella/menores/bastos/as.jpg": 16556,
	"./assets/marsella/menores/bastos/caballo.jpg": 25114,
	"./assets/marsella/menores/bastos/cinco.jpg": 38964,
	"./assets/marsella/menores/bastos/cuatro.jpg": 87337,
	"./assets/marsella/menores/bastos/diez.jpg": 71100,
	"./assets/marsella/menores/bastos/dos.jpg": 25921,
	"./assets/marsella/menores/bastos/nueve.jpg": 27806,
	"./assets/marsella/menores/bastos/ocho.jpg": 54875,
	"./assets/marsella/menores/bastos/reina.jpg": 6906,
	"./assets/marsella/menores/bastos/rey.jpg": 29875,
	"./assets/marsella/menores/bastos/seis.jpg": 91224,
	"./assets/marsella/menores/bastos/siete.jpg": 35233,
	"./assets/marsella/menores/bastos/sota.jpg": 22810,
	"./assets/marsella/menores/bastos/tres.jpg": 84535,
	"./assets/marsella/menores/copas/as.jpg": 15290,
	"./assets/marsella/menores/copas/caballo.jpg": 407,
	"./assets/marsella/menores/copas/cinco.jpg": 64972,
	"./assets/marsella/menores/copas/cuatro.jpg": 90625,
	"./assets/marsella/menores/copas/diez.jpg": 3059,
	"./assets/marsella/menores/copas/dos.jpg": 32833,
	"./assets/marsella/menores/copas/nueve.jpg": 23092,
	"./assets/marsella/menores/copas/ocho.jpg": 95802,
	"./assets/marsella/menores/copas/reina.jpg": 41362,
	"./assets/marsella/menores/copas/rey.jpg": 44167,
	"./assets/marsella/menores/copas/seis.jpg": 52389,
	"./assets/marsella/menores/copas/siete.jpg": 19675,
	"./assets/marsella/menores/copas/sota.jpg": 53595,
	"./assets/marsella/menores/copas/tres.jpg": 38493,
	"./assets/marsella/menores/espadas/as.jpg": 37434,
	"./assets/marsella/menores/espadas/caballo.jpg": 6846,
	"./assets/marsella/menores/espadas/cinco.jpg": 55612,
	"./assets/marsella/menores/espadas/cuatro.jpg": 56224,
	"./assets/marsella/menores/espadas/diez.jpg": 82515,
	"./assets/marsella/menores/espadas/dos.jpg": 88577,
	"./assets/marsella/menores/espadas/nueve.jpg": 86442,
	"./assets/marsella/menores/espadas/ocho.jpg": 59211,
	"./assets/marsella/menores/espadas/reina.jpg": 53407,
	"./assets/marsella/menores/espadas/rey.jpg": 6294,
	"./assets/marsella/menores/espadas/seis.jpg": 26650,
	"./assets/marsella/menores/espadas/siete.jpg": 63904,
	"./assets/marsella/menores/espadas/sota.jpg": 84471,
	"./assets/marsella/menores/espadas/tres.jpg": 87553,
	"./assets/marsella/menores/oros/as.jpg": 93948,
	"./assets/marsella/menores/oros/caballo.jpg": 45180,
	"./assets/marsella/menores/oros/cinco.jpg": 18487,
	"./assets/marsella/menores/oros/cuatro.jpg": 16288,
	"./assets/marsella/menores/oros/diez.jpg": 17145,
	"./assets/marsella/menores/oros/dos.jpg": 11424,
	"./assets/marsella/menores/oros/nueve.jpg": 42568,
	"./assets/marsella/menores/oros/ocho.jpg": 50295,
	"./assets/marsella/menores/oros/reina.jpg": 24173,
	"./assets/marsella/menores/oros/rey.jpg": 11553,
	"./assets/marsella/menores/oros/seis.jpg": 63419,
	"./assets/marsella/menores/oros/siete.jpg": 7372,
	"./assets/marsella/menores/oros/sota.jpg": 57928,
	"./assets/marsella/menores/oros/tres.jpg": 34327,
	"./assets/vids/eight.mp4": 2505,
	"./assets/vids/five.mp4": 54503,
	"./assets/vids/four.mp4": 55903,
	"./assets/vids/nine.mp4": 91586,
	"./assets/vids/one.mp4": 84430,
	"./assets/vids/seven.mp4": 34994,
	"./assets/vids/six.mp4": 71637,
	"./assets/vids/ten.mp4": 26737,
	"./assets/vids/three.mp4": 86331,
	"./assets/vids/two.mp4": 67747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97148;